import { RootContainer } from "../../../../root_container";
import { MyCatalogRegisterAction } from "../../../../actions/my_catalog_register/my_catalog_register_action";
import { MyCatalogModal } from '../../../../models/my_catalog_register/my_catalog_modal';
import { RrBodyMyCatalogModal } from "./rr_body";

export class RrItemModalContainer extends RootContainer<MyCatalogModal> {
  constructor() {
    super();

    MyCatalogRegisterAction.RR_ITEM_Modal_EVENT.on((model: MyCatalogModal) => {
      // 同じ「選択したフォルダに登録」ボタンを押下するとmount設定が重複するためcomponentsを初期化
      this.components = [];
      this.mount(RrBodyMyCatalogModal, model.rrAreaProfileMyCatalogModal!.placementName)
      this.update(model);
    
      const WindowCarousel = window._carousel;
      new WindowCarousel( // NOSONAR
        `#${model.rrAreaProfileMyCatalogModal!.placementName}`
      );
    });
  }
}